// extracted by mini-css-extract-plugin
module.exports = {"clickable":"icon_clickable__2wdT9"};